module.exports = "https://static.wmbcdn.com/uniweb/images/92914fa35963dc7251655ce1a154a2fc.svg";